export default __webpack_public_path__ + "img/cart.svg";